import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-suitcase",
  templateUrl: "./med-icon-suitcase.component.html",
})
export class MedIconSuitcaseComponent extends SvgMixinComponent {}
